import api from './api';

export interface Visitor {
  id: string;
  store_id: string;
  name: string;
  contact_number: string;
  reason: string;
  photo_url?: string | null;
  photo_s3_key?: string | null;
  visit_date: string;
  entry_time: string;
  exit_time?: string | null;
  registered_by: string;
  exit_updated_by?: string | null;
  notes?: string | null;
  created_at: string;
  updated_at: string;
  store?: {
    id: string;
    name: string;
    address?: string | null;
  };
  registrar?: {
    id: string;
    first_name: string;
    last_name: string;
    employee_id: string;
  };
  exit_updater?: {
    id: string;
    first_name: string;
    last_name: string;
    employee_id: string;
  } | null;
}

export interface GetVisitorsParams {
  store_id?: string;
  visit_date?: string;
  start_date?: string;
  end_date?: string;
  search?: string;
  name?: string;
  contact_number?: string;
  has_exit?: boolean;
  page?: number;
  limit?: number;
}

export interface PaginatedVisitorResponse {
  visitors: Visitor[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const visitorService = {
  /**
   * Get visitors with filters
   */
  getVisitors: async (params?: GetVisitorsParams): Promise<PaginatedVisitorResponse> => {
    const response = await api.get<{ success: boolean; message: string; data: PaginatedVisitorResponse }>('/visitors', {
      params,
    });
    return response.data.data;
  },

  /**
   * Get visitor by ID
   */
  getVisitorById: async (id: string): Promise<Visitor> => {
    const response = await api.get<{ success: boolean; message: string; data: Visitor }>(`/visitors/${id}`);
    return response.data.data;
  },

  /**
   * Update visitor exit time
   */
  updateExitTime: async (id: string, exitTime: string, notes?: string): Promise<Visitor> => {
    const response = await api.patch<{ success: boolean; message: string; data: Visitor }>(
      `/visitors/${id}/exit`,
      {
        exit_time: exitTime,
        ...(notes && { notes }),
      }
    );
    return response.data.data;
  },
};

export default visitorService;

